<div class="wrapper">
  <div class="iconWrapper">
    <gl-icon class="loadIcon" name="load"></gl-icon>
  </div>

  <div class="description">
    <div class="loadName">
      {{ load?.name | translate }}
    </div>
    @if (load.loadType === 0) {
      <div class="loadDimmension">
        {{ load?.length }} x {{ load?.width }} x {{ load?.height | unit: 'length':false }} |
        {{ load?.weight | unit: 'weight':false }}
      </div>
    }
    @if (load.loadType === 1) {
      <div class="loadDimmension">
        {{ load?.diameter }} x {{ load?.height | unit: 'length':false }} |
        {{ load?.weight | unit: 'weight':false }}
      </div>
    }
    @if (load.loadType === 2) {
      <div class="loadDimmension">
        {{ load?.diameter }} x {{ load?.length | unit: 'length':false }} |
        {{ load?.weight | unit: 'weight':false }}
      </div>
    }
  </div>
  <div class="buttons">
    @if (isQuick) {
      <input
        type="number"
        class="loadQty"
        [class.loadQtyDisabled]="individualAddBlocked"
        [(ngModel)]="loadQty"
        [disabled]="individualAddBlocked"
        />
    }
    @if (isQuick) {
      <button small-icon-button (click)="changeLoadStacking()" class="stackButton"
        [ngClass]="{'active': isLoadStacked}">
        <gl-icon name="stackIcon" [glTooltip]="'stack' | translate"></gl-icon>
      </button>
    }
    <span
      class="addButtonWrapper"
      [glTooltip]="individualAddBlocked ? 'individual_add_blocked_stacking_mode' : null"
      [disableTooltip]="!individualAddBlocked"
      >
      <button
        small-button
        (click)="addLoad($event)"
        [glPremium]="load.isUser"
        [class.actionBlocked]="individualAddBlocked"
        data-ctx="button-add-load"
        >
        {{ 'add' | translate }}
      </button>
    </span>
    <button small-icon-button (click)="editLoad($event)" data-ctx="button-edit-load">
      <gl-icon name="edit"></gl-icon>
    </button>
  </div>
</div>
